<template>
  <VueSlider
    class="c-slider"
    v-bind="$attrs"
    v-on="$listeners"
    v-model="innerValue"
    ref="slider"
    :class="type"
    :height="height"
    :width="width"
    :dot-size="dotSize"
    :speed="0.2"
    :lazy="true"
    :piecewise="true"
    :min="min"
    :max="max"
    :tooltip="false"
    :disabled="disabled"
    :bg-style="bgStyle"
    :slider-style="sliderStyle"
    :process-style="processStyle"
    :piecewise-style="piecewiseStyle"
    :piecewise-active-style="piecewiseActiveStyle"
  >
    <template slot="label" slot-scope="{ index, active }" v-if="values.length">
      <span :class="['c-slider_label', { active }]" v-if="values[index].text">
        {{ values[index].text }}
      </span>
    </template>
  </VueSlider>
</template>
<script>
let components = {}

if (process.browser) {
  let VueSlider = require('vue-slider-component')
  components['VueSlider'] = VueSlider
}

export default {
  name: 'CSlider',
  components,
  props: {
    value: {
      type: [Number, String],
      default: 1
    },
    values: {
      type: Array,
      default() {
        return []
      }
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 10
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    dotSize: {
      type: Number,
      default: 20
    },
    height: {
      type: String,
      default: '8'
    },
    width: {
      type: String,
      default: '200'
    },
    bgStyle: {
      type: Object,
      default() {
        return {
          backgroundColor: '#ccc',
          cursor: 'pointer'
        }
      }
    },
    sliderStyle: {
      type: Object,
      default() {
        return {
          backgroundColor: '#28a7e1',
          boxShadow: 'none'
        }
      }
    },
    processStyle: {
      type: Object,
      default() {
        return {
          backgroundColor: '#28a7e1'
        }
      }
    },
    piecewiseStyle: {
      type: Object,
      default() {
        return {
          visibility: 'visible',
          width: '8px',
          height: '8px',
          backgroundColor: '#999'
        }
      }
    },
    piecewiseActiveStyle: {
      type: Object,
      default() {
        return {
          backgroundColor: '#28a7e1'
        }
      }
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-slider {
  margin-top: calc(1em + 6px);
  &_label {
    position: absolute;
    bottom: 100%;
    left: 0;
    transform: translate(-50%, -6px);
    margin-left: 3px;
    white-space: nowrap;
    font-size: 12px;
  }

  &.request-detail {
    margin-top: 1px;

    &.vue-slider-disabled {
      opacity: 1;
      cursor: default !important;
    }

    /deep/ .vue-slider {
      cursor: default !important;

      .vue-slider-dot {
        cursor: default;
      }

      .vue-slider-piecewise {
        .vue-slider-piecewise-item {
          .vue-slider-piecewise-dot {
            border-radius: 0;
            outline: 2px solid $color-white;
          }
        }
      }
    }
  }
}
</style>
